{
  "static-content-online-booking-benefit": {
    "buttons": {},
    "text": {
      "title-1": "Rezervujte online a ",
      "title-2": "odemkněte exkluzivní výhody!",
      "description": "Zažijte maximální pohodlí s naším online rezervačním nástrojem. Ať je den nebo noc, můžete si naplánovat schůzku 24 hodin denně, 7 dní v týdnu odkudkoli, pouze pomocí chytrého zařízení a připojení k internetu. Navíc získáte přístup ke speciálním nabídkám, jako jsou slevy a exkluzivní akce v rámci happy hour. Mějte své schůzky pod kontrolou a využívejte výhod bezproblémové online rezervace!",
      "any-time-title": "Rezervace 24/7",
      "any-time-description": "Rezervujte si schůzku online bez ohledu na čas.",
      "any-where-title": "Rezervujte odkudkoli",
      "any-where-description": "Z postele nebo na cestě",
      "discount-title": "Nejlepší nabídky",
      "discount-description": "Nenechte si ujít naše nejlepší nabídky! Získejte nyní skvělé slevy a exkluzivní nabídky na šťastné hodiny"
    }
  }
}
